import React from 'react';
import css from './index.module.scss';

interface MacBookProps {
  imgUrl: string;
  className?: string;
}

export const MacBook = (props: MacBookProps) => {
  const imgId = props.imgUrl;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="727"
      height="421"
      fill="none"
      viewBox="0 0 727 421"
      className={props.className}
    >
      <path
        fill="#121212"
        fillRule="evenodd"
        d="M90 1C77.297 1 67 11.297 67 24v373h593V24c0-12.703-10.297-23-23-23H90z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#C5C5C5"
        strokeWidth="2"
        d="M659 403H68V23c0-12.15 9.85-22 22-22h547c12.15 0 22 9.85 22 22v380z"
      ></path>
      <path
        fill={`url(#${imgId})`}
        fillRule="evenodd"
        d="M86 26v348h556V26H86z"
        clipRule="evenodd"
      ></path>
      <path
        fill="url(#paint0_linear)"
        fillRule="evenodd"
        d="M364 20a4 4 0 100-8 4 4 0 000 8z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#103470"
        fillRule="evenodd"
        d="M364 18a2 2 0 100-4 2 2 0 000 4z"
        clipRule="evenodd"
      ></path>
      <path
        fill="url(#paint1_linear)"
        fillRule="evenodd"
        d="M.595 410.621s7.577 7.568 29.032 9.567h667.744s17.801-1.339 29.348-9.237H17.42l-16.825-.33z"
        clipRule="evenodd"
      ></path>
      <path
        fill="url(#paint2_linear)"
        fillRule="evenodd"
        d="M1 397v14h726v-14H1z"
        clipRule="evenodd"
      ></path>
      <g filter="url(#filter0_i)">
        <path
          fill="url(#paint3_linear)"
          fillRule="evenodd"
          d="M312.427 397.463s.083 5.792 5.88 8.558h90.146s4.959-1.8 6.063-8.558H313.889"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_i"
          width="102.088"
          height="8.558"
          x="312.427"
          y="397.463"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          ></feFlood>
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
          <feComposite
            in2="hardAlpha"
            k2="-1"
            k3="1"
            operator="arithmetic"
          ></feComposite>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.301442 0"></feColorMatrix>
          <feBlend in2="shape" result="effect1_innerShadow"></feBlend>
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="360"
          x2="360"
          y1="12"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#151515"></stop>
          <stop offset="1" stopColor="#2C2C2C"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="0.595"
          x2="0.595"
          y1="410.621"
          y2="420.188"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#96979B"></stop>
          <stop offset="1" stopColor="#2A2B2D"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="727"
          x2="1"
          y1="397"
          y2="397"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#808185"></stop>
          <stop offset="0.002" stopColor="#CFD0D4"></stop>
          <stop offset="0.008" stopColor="#CFD0D2"></stop>
          <stop offset="0.021" stopColor="#949599"></stop>
          <stop offset="0.037" stopColor="#A7A8AC"></stop>
          <stop offset="0.042" stopColor="#B6B7BB"></stop>
          <stop offset="0.096" stopColor="#D8D8D8"></stop>
          <stop offset="0.909" stopColor="#DDDEE0"></stop>
          <stop offset="0.956" stopColor="#B1B2B4"></stop>
          <stop offset="0.983" stopColor="#C2C3C7"></stop>
          <stop offset="0.991" stopColor="#F1F3F2"></stop>
          <stop offset="0.994" stopColor="#E9EBEA"></stop>
          <stop offset="0.997" stopColor="#D4D5D7"></stop>
          <stop offset="1" stopColor="#7A7B7F"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear"
          x1="414.516"
          x2="312.427"
          y1="396.371"
          y2="396.371"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#949599"></stop>
          <stop offset="0.036" stopColor="#9E9FA3"></stop>
          <stop offset="0.052" stopColor="#B9BABC"></stop>
          <stop offset="0.086" stopColor="#E0E1E3"></stop>
          <stop offset="0.918" stopColor="#D8D9DB"></stop>
          <stop offset="0.945" stopColor="#C2C3C5"></stop>
          <stop offset="1" stopColor="#8D8E90"></stop>
        </linearGradient>
        <pattern
          id={imgId}
          patternContentUnits="objectBoundingBox"
          width="100%"
          height="100%"
          className={css.img}
        >
          <image
            href={props.imgUrl}
            height="1"
            width="1"
            preserveAspectRatio="none"
          />
        </pattern>
      </defs>
    </svg>
  );
};
